module.exports = __webpack_public_path__ + "img/select-check-on_y.6bbe414b.svg";